var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhlFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v22.5H0V0Z",
    fill: "#0038A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 22.5h60V45H0V22.5Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.972 22.5 0 45V0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.503 3.975 1.34 1.181L5.4 4.294l-.694 1.64 1.313 1.22-1.782-.15-.759 1.612-.403-1.735-1.763-.225 1.529-.937-.338-1.744ZM32.86 20.128l.038 1.782 1.687.59-1.687.581-.038 1.782-1.078-1.416-1.706.516 1.012-1.463-1.012-1.462 1.706.515 1.078-1.425ZM3.487 36.385l.75 1.612 1.782-.15-1.303 1.219.693 1.64-1.556-.853-1.35 1.163.338-1.753-1.529-.92 1.772-.224.403-1.734ZM14.195 13.04l-.582.581.291 4.406-.281.028-.534-4.022-.479.47.713 3.6a4.452 4.452 0 0 0-1.613.665L9.675 15.73H9l2.475 3.216c-.077.06-.152.123-.225.188l-2.916-3.329H7.51v.825l3.32 2.907-.188.234-3.216-2.466v.666l3.047 2.034a4.522 4.522 0 0 0-.666 1.613l-3.59-.713-.479.47 4.022.534a1.525 1.525 0 0 0-.028.29l-4.406-.281-.581.581.581.581 4.406-.29.028.29-4.022.535.47.468 3.6-.712c.113.576.339 1.124.665 1.613l-3.047 2.034v.675l3.216-2.466c.06.077.122.152.187.225L7.51 28.36v.825h.835l2.906-3.32.234.188L9 29.27h.675l2.034-3.047a4.454 4.454 0 0 0 1.613.666l-.713 3.6.47.468.534-4.021c.093.018.187.028.29.028l-.281 4.406.572.581.59-.581-.29-4.406.281-.029.534 4.032.479-.478-.713-3.6a4.454 4.454 0 0 0 1.613-.666l2.034 3.047h.675l-2.475-3.216c.077-.06.152-.122.225-.187l2.916 3.319h.825v-.825l-3.32-2.907.188-.225 3.216 2.466v-.675l-3.047-2.034a4.455 4.455 0 0 0 .666-1.613l3.59.712.478-.468-4.021-.535c.018-.093.028-.187.028-.29l4.406.281.581-.572-.581-.581-4.406.281-.029-.281 4.022-.535-.468-.468-3.6.703a4.454 4.454 0 0 0-.666-1.613l3.047-2.034v-.666l-3.216 2.466a4.423 4.423 0 0 0-.187-.225l3.319-2.906v-.835h-.826l-2.906 3.329a4.492 4.492 0 0 0-.234-.188l2.475-3.216h-.675l-2.035 3.038a4.454 4.454 0 0 0-1.612-.666l.713-3.59-.47-.47-.534 4.013-.29-.028.281-4.406-.581-.581Z",
    fill: "#FCD116"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhlFlag);
export default __webpack_public_path__ + "static/media/phl-flag.c9faf5c65b16824245217262f2462373.svg";
export { ForwardRef as ReactComponent };